import {Component, EventEmitter, Injector, Input, Output} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {AssociationService} from "../associactions/services/association.service";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-certification-condition-check-list',
    templateUrl: './certification-condition-check.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class CertificationConditionCheckComponent extends BasePageComponentDirective<any> {

    activities: any[] = [];
    conditionChecked: any[] = [];

    providerId: number = null;

    @Input() form: FormGroup;
    @Input() mode = 'new';
    @Input() certification: any = null;
    @Input() conditions: any[] = [];
    @Output() activityChecked: any = new EventEmitter();

    showCloseSearch = false;

    constructor(
        injector: Injector,
        private associationService: AssociationService,
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.tableLoading = false;
        this.form.controls.providerId.valueChanges.subscribe(r => {
            this.providerId = r;
            this.query();
        });

        this.form.controls.conditions.valueChanges.subscribe(r => {
            if(this.mode != 'new') {
                this.conditionChecked = r;
            }
        });
    }

    query(): void {
        this.tableLoading = true;
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['activityType'];
        this.associationService.getActivitiesByProviderId(this.pageQuery, this.providerId).then(r => {
            this.activities = r.content;
            this.page.emit(r);
        });
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.searchTerm = this.pageQuery.search;
            this.query();
            this.showCloseSearch = true;
        }
    }

    clearSearch() {
        this.searchTerm = '';
        this.pageQuery.search = '';
        this.query();
        this.showCloseSearch = false;
    }

    addRemoveActivity(checked: MatCheckboxChange, providerActivityId: number) {
        this.activityChecked.emit({checked: checked.checked, providerActivityId: providerActivityId});
        if(checked.checked) {
            if(this.conditionChecked.find(r => r.providerActivityId === providerActivityId) == null) {
                this.conditionChecked.push({providerActivityId: providerActivityId});
            }
        } else {
            this.conditionChecked = this.conditionChecked.filter(r => r.providerActivityId != providerActivityId);
        }
    }

    shouldCheckCondition(activityId: number) {
        console.log(activityId, this.conditions)
        if(this.conditions) {
            let x = this.conditions.find((r: { id: number; }) => r.id === activityId);
            console.log(x != null)
            return x != null;
        }
        return false;
    }
}
